import * as React from 'react';
import { ReactNode, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@emorg-prd/standard-react';

type sizeValues = 'em-c-modal--large';

interface StandardModalProps {
  show: boolean;
  onDismiss: () => void;
  title: string;
  kicker?: string;
  icon?: any; 
  children: ReactNode;
  footer?: ReactNode;
  optionalClass?: string;
  size?: sizeValues;
  blockOverlayClick?: boolean;
}

const StandardModal = ({
  show,
  onDismiss,
  title,
  kicker,
  icon,
  children,
  footer,
  optionalClass = '',
  size,
  blockOverlayClick = false
}: StandardModalProps) => {
  const modalClass = optionalClass || 'standard-modal-wrapper';

  useEffect(() => {
    if (!show) return;

    const timeoutId = setTimeout(() => {
      const modalRoot = document.querySelector(`.${modalClass}`);
      if (!modalRoot) return;

      const closeBtn = modalRoot.querySelector(".em-c-modal__close-btn");
      const overlay = modalRoot.querySelector(".em-c-modal__overlay");

      const syncClose = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();
        onDismiss();
      };

      closeBtn?.addEventListener("click", syncClose, true);
      
      if (!blockOverlayClick) {
        overlay?.addEventListener("click", syncClose, true);
      }

      (window as any).__standardModalCleanup = () => {
        closeBtn?.removeEventListener("click", syncClose, true);
        if (!blockOverlayClick) {
          overlay?.removeEventListener("click", syncClose, true);
        }
      };
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      if ((window as any).__standardModalCleanup) {
        (window as any).__standardModalCleanup();
        delete (window as any).__standardModalCleanup;
      }
    };
  }, [show, onDismiss, modalClass, blockOverlayClick]);

  if (!show) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="em-js-modal-trigger"
        style={{ display: 'none' }}
        aria-hidden="true"
      >
        <span className="em-c-primary-nav__link" />
      </button>

      <Modal
        show={show}
        optionalClass={optionalClass || 'standard-modal-wrapper'}
        size={size}
      >
        <ModalHeader
          onClick={onDismiss}
          title={title}
          kicker={kicker}
          {...(icon && { icon })}
        />
        <ModalBody>
          {children}
        </ModalBody>
        {footer && (
          <ModalFooter>
            {footer}
          </ModalFooter>
        )}
      </Modal>
    </>
  );
};

export default StandardModal;
